export var ApiAuthType;
(function (ApiAuthType) {
    ApiAuthType["Password"] = "Password";
    ApiAuthType["Token"] = "Token";
    ApiAuthType["ActiveDirectoryFederationServices"] = "ADFS";
    ApiAuthType["AzureActiveDirectory"] = "AAD";
    ApiAuthType["Okta"] = "Okta";
    ApiAuthType["ItsMe"] = "ItsMe";
})(ApiAuthType || (ApiAuthType = {}));
